import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
  scmAuthApiRef,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import { TechRadarClient } from './lib/TechRadarClient';
import { catalogImportApiRef } from '@backstage/plugin-catalog-import';
import { ImportOverride } from './components/catalog/ImportOverride';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import {
  graphQlBrowseApiRef,
  GraphQLEndpoints,
} from '@backstage-community/plugin-graphiql';
import {
  TechInsightsClient,
  techInsightsApiRef,
} from '@backstage-community/plugin-tech-insights-react';
import { atgCheckResultRenderer } from './lib/techInsightsCheckResultRenderer';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  createApiFactory({
    api: catalogImportApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      scmAuthApi: scmAuthApiRef,
      identityApi: identityApiRef,
      scmIntegrationsApi: scmIntegrationsApiRef,
      catalogApi: catalogApiRef,
      configApi: configApiRef,
    },
    factory: ({
      discoveryApi,
      scmAuthApi,
      identityApi,
      scmIntegrationsApi,
      catalogApi,
      configApi,
    }) =>
      new ImportOverride({
        discoveryApi,
        scmAuthApi,
        scmIntegrationsApi,
        identityApi,
        catalogApi,
        configApi,
      }),
  }),
  createApiFactory({
    api: graphQlBrowseApiRef,
    deps: {},
    factory: () =>
      GraphQLEndpoints.from([
        // use the create function to connect an unauthenticated GraphQL API
        GraphQLEndpoints.create({
          id: 'calendar-service',
          title: 'Calendar service',
          url: 'https://calendar-service.core.platform.stage-atgtickets.com',
          // headers: { 'Some-Key': 'Some-Value' }
        }),
        GraphQLEndpoints.create({
          id: 'voucher-service',
          title: 'Voucher service',
          url: 'https://voucher-service-stage.atgtickets.com/graphql',
        }),
      ]),
  }),
  createApiFactory(techRadarApiRef, new TechRadarClient()),
  // The stock tech-insights client, with one renderer swapped in. It shows a
  // check the backend could not evaluate as such, rather than as a failure.
  createApiFactory({
    api: techInsightsApiRef,
    deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
    factory: ({ discoveryApi, identityApi }) =>
      new TechInsightsClient({
        discoveryApi,
        identityApi,
        renderers: [atgCheckResultRenderer],
      }),
  }),
  ScmAuth.createDefaultApiFactory(),
];
